export default __webpack_public_path__ + "static/media/sling.23a75ec2.png";